import { createContext, useContext } from 'react'

export interface MapInteractionContextValue {
  /** Called when a hotel card is hovered (from carousel or explore drawer). Updates isCardHoveredRef + hoveredHotelId. */
  onCardHover: (offerId: string | undefined) => void
  /** Called when a map marker is hovered. Guards against clearing hover while a card is actively hovered. */
  onMarkerHover: (markerId: string | undefined) => void
  /** Currently highlighted hotel/marker ID for visual sync between map and card lists */
  highlightedMarkerId: string | undefined
}

const MapInteractionContext = createContext<MapInteractionContextValue | undefined>(undefined)

export const MapInteractionProvider = MapInteractionContext.Provider

export function useMapInteraction(): MapInteractionContextValue {
  const ctx = useContext(MapInteractionContext)
  if (!ctx) throw new Error('useMapInteraction must be used within MapInteractionProvider')
  return ctx
}
